import type {
  AssignMbcAdminDefaultGuidelineBody,
  AssignMbcAdminGuidelineBody,
  GetMbcCatalogResponse,
  ListMbcAdminAssignmentsResponse,
  SetMbcDesignTypeBody,
  SetMbcDesignTypeResponse,
} from "@nlc/shared-types";

import apiClient from "@/lib/api/client";

import type { GuidelineScope } from "../guideline-scope";

import { adminRequest } from "../adminRequest";

export function getCatalog(): Promise<GetMbcCatalogResponse> {
  return apiClient.url("/mbc-admin/catalog").get().json();
}

export function listAssignments(): Promise<ListMbcAdminAssignmentsResponse> {
  return adminRequest<ListMbcAdminAssignmentsResponse>("/assignments");
}

export async function assignGuideline({
  scope,
  ...body
}: {
  scope: GuidelineScope;
} & AssignMbcAdminGuidelineBody): Promise<void> {
  const path =
    scope.kind === "designType"
      ? `/assignments/design-types/${scope.designTypeId}`
      : `/assignments/sub-categories/${scope.subCategoryId}`;

  await adminRequest(path, "PUT", body);
}

export async function assignDefaultGuideline(
  body: AssignMbcAdminDefaultGuidelineBody,
): Promise<void> {
  await adminRequest("/assignments/default", "PUT", body);
}

export async function setDesignTypeMbc({
  designTypeId,
  enabled,
}: {
  designTypeId: number;
  enabled: boolean;
}): Promise<void> {
  await apiClient
    .url(`/mbc-admin/design-types/${designTypeId}`)
    .patch({ enabled } satisfies SetMbcDesignTypeBody)
    .json<SetMbcDesignTypeResponse>();
}
